import {
  boldFont,
  getRelativeFontSize,
  mediumFont,
  theme,
} from "../../utils/styles";

const layoutStyles = {
  content: {
    height: `calc(100vh - 68px)`,
    marginTop: "68px",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    backgroundColor: "#FFFFFF",
    overflow: "auto",
  },
  root: {
    display: "flex",
    backgroundColor: "#FFFFFF",
    minHeight: "100vh",
    overflow: "hidden",
  },
  dropZoneWrapper: {
    "& .MuiDropzoneArea-root": {
      width: "100%",
      minHeight: "70px",
      fontSize: "12px",
      borderRadius: "10px",
      borderWidth: "3px",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
    },
    "& .MuiDropzoneArea-text": {
      fontSize: getRelativeFontSize(2),
      ...mediumFont,
    },
  },
  warningContent: {
    color: "red",
    fontSize: getRelativeFontSize(),
    margin: "10px 0",
    ...mediumFont,
  },
  supportTicket: {
    position: "absolute",
    right: "25px",
    bottom: "0px",
    cursor: "pointer",
  },
  supportTicketClose: {
    position: "absolute",
    right: "10px",
    zIndex: "1",
  },
  supportTicketIcon: {
    position: "relative",
  },
  supportTicketTitleWrapper: {
    width: "100%",
    background: "#FCF5FF",
    display: "flex",
    justifyContent: "center",
    "& img": {
      [theme.breakpoints.down("lg")]: {
        width: "50%",
      },
    },
  },
  supportTicketTitle: {
    textAlign: "center",
    ...boldFont,
    fontSize: getRelativeFontSize(14),
  },
  formInput: {
    width: "100%",
    "& .MuiDropzoneArea-root": {
      width: "100%",
      minHeight: "10px",
    },
  },
  label: {
    ...boldFont,
    marginBottom: "8px",
  },
  star: {
    color: "gray",
    ...boldFont,
  },
  selectStyle: {
    width: "100%",
    height: "45px",
    borderRadius: "10px",
    ...mediumFont,
    "&.Mui-focused fieldset": {
      borderColor: "#4B0150 !important",
    },
  },
  optionStyle: {
    ...mediumFont,
  },
  testAreaStyle: {
    borderRadius: "12px",
    borderColor: "rgba(0,0,0,0.2)",
    background: "none",
    padding: "10px",
  },
  testAreaStyleError: {
    borderColor: "red",
    borderRadius: "12px",
    background: "none",
    padding: "10px",
  },
  submitButton: {
    width: "200px",
    margin: "20px 0",
  },
  previewChip: {
    marginTop: 1,
    padding: "15px 0px",
    justifyContent: "space-between",
  },

  errorStyle: {
    paddingLeft: "15px",
  },
} as const;

export default layoutStyles;
